<template>
  <div>
    <v-card v-if="shippingLoading" class="common-card-log">
      <div class="d-flex flex-column align-items-center mt-8 py-6">
        <looping-rhombuses-spinner
          :animation-duration="2500"
          :rhombus-size="15"
          color="#a076f9"
          class="mx-auto my-10"
        />
      </div>
    </v-card>

    <div v-else class="root_purchase_process">
      <v-col xl="12" lg="12" md="12" sm="12" xs="12" class="py-0" cols="12">
        <div class="title_Product_Details">
          <v-breadcrumbs :items="items" class="pt-0"></v-breadcrumbs>
        </div>
      </v-col>
      <v-col xl="8" lg="8" md="7" sm="12" xs="12" class="py-0" cols="12">
        <v-col xl="12" lg="12" md="12" sm="12" xs="12" class="p-0" cols="12">
          <div v-if="!userHasName">
            <v-card class="common-card-log">
              <div>
                <v-col
                  xl="12"
                  lg="12"
                  md="12"
                  sm="12"
                  xs="12"
                  cols="12"
                  class="py-0"
                >
                  <v-icon>mdi-alert</v-icon>
                  <h6 class="fontSizemedium font-weight-bold mainFont--text">
                    به منظور ثبت سفارش لطفا نام و نام خانوادگی خود را وارد
                    نمایید.
                  </h6>
                </v-col>
              </div>

              <v-row justify="end" class="mt-2">
                <v-col xl="9" lg="8" md="7" sm="8" xs="12" cols="12">
                  <v-text-field
                    outlined
                    dense
                    hide-details
                    label="نام و نام خانوادگی"
                    v-model="userName"
                  >
                  </v-text-field>
                </v-col>
                <v-col xl="3" lg="4" md="5" sm="4" xs="12" cols="12">
                  <v-btn
                    block
                    class="d-flex justify-space-between purple-borderedBtn"
                    :disabled="!userName"
                    @click="editName()"
                  >
                    <span class="fs-small">ثبت نام و نام خانوادگی</span>
                    <v-icon>mdi-account-edit</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
          </div>
        </v-col>
        <v-col
          xl="12"
          lg="12"
          md="12"
          sm="12"
          xs="12"
          class="p-0 my-2"
          cols="12"
        >
          <div>
            <v-card class="common-card-log">
              <div>
                <v-col
                  xl="12"
                  lg="12"
                  md="12"
                  sm="12"
                  xs="12"
                  cols="12"
                  class="py-0"
                  v-if="!isUserAddressCompleted"
                >
                  <h6 class="fontSizemedium font-weight-bold mainFont--text">
                    آدرس تحویل سفارش را تعیین نمایید.
                  </h6>
                </v-col>
                <v-col
                  xl="12"
                  lg="12"
                  md="12"
                  sm="12"
                  xs="12"
                  cols="12"
                  class="py-0"
                  v-if="isUserAddressCompleted"
                >
                  <h6 class="fontSizemedium font-weight-bold mainFont--text">
                    آدرس تحویل سفارش
                  </h6>
                </v-col>
              </div>
              <v-col xl="12" lg="12" md="12" sm="12" xs="12" cols="12">
                <div class="items_addres_box" v-if="selectedAddress">
                  <div v-if="selectedAddress.stateName">
                    <v-icon color="primary">mdi-map-marker-outline</v-icon>
                  </div>
                  <div
                    class="font-weight-bold fs-small mr-2"
                    v-if="selectedAddress.stateName"
                  >
                    <h6 class="font-weight-bold fs-small">
                      {{ selectedAddress.stateName }} ,
                    </h6>
                  </div>
                  <div
                    class="details_addres_box"
                    v-if="selectedAddress.cityName"
                  >
                    <h6 class="font-weight-bold fs-small">
                      {{ selectedAddress.cityName }} ,
                    </h6>
                  </div>
                  <div
                    class="details_addres_box"
                    v-if="selectedAddress.district"
                  >
                    <h6 class="font-weight-bold fs-small">منطقه:</h6>
                    <h6 class="font-weight-bold fs-small">
                      {{ selectedAddress.district }}
                    </h6>
                  </div>
                  <div class="details_addres_box" v-if="selectedAddress">
                    <h6
                      class="font-weight-bold fs-small"
                      v-if="selectedAddress.address"
                    >
                      {{ selectedAddress.address }}
                    </h6>
                  </div>
                </div>
              </v-col>

              <v-col
                xl="12"
                lg="12"
                md="12"
                sm="12"
                xs="12"
                cols="12"
                class="py-0"
                v-if="selectedAddress"
              >
                <div class="details_addres_box" v-if="selectedAddress.name">
                  <v-icon color="primary" class="pb-2"
                    >mdi-account-outline
                  </v-icon>
                  <h6 class="font-weight-bold fs-small pr-2">نام گیرنده:</h6>
                  <h5 class="font-weight-bold fs-small">
                    {{ selectedAddress.name }}
                  </h5>
                </div>
              </v-col>

              <v-col
                xl="12"
                lg="12"
                md="12"
                sm="12"
                xs="12"
                cols="12"
                class="py-0"
                v-if="selectedAddress"
              >
                <div
                  class="details_addres_box pt-3"
                  v-if="selectedAddress.mobile"
                >
                  <v-icon color="primary" class="">mdi-cellphone</v-icon>
                  <h6 class="font-weight-bold fs-small pr-2">موبایل گیرنده:</h6>
                  <h5 class="font-weight-bold fs-small">
                    {{ selectedAddress.mobile }}
                  </h5>
                </div>
              </v-col>

              <v-col
                xl="12"
                lg="12"
                md="12"
                sm="12"
                xs="12"
                cols="12"
                class="py-0"
                v-if="selectedAddress"
              >
                <div
                  class="details_addres_box pt-3"
                  v-if="selectedAddress.postalCode"
                >
                  <v-icon color="primary" class="pb-2">mdi-email</v-icon>
                  <h6 class="font-weight-bold fs-small pr-2">کد پستی:</h6>
                  <h5 class="font-weight-bold fs-small">
                    {{ selectedAddress.postalCode }}
                  </h5>
                </div>
              </v-col>
              <v-row justify="end" class="mt-2">
                <v-col xl="3" lg="4" md="5" sm="4" xs="12" cols="12">
                  <v-btn
                    block
                    class="d-flex justify-space-between purple-borderedBtn"
                    @click="handelOpenModal()"
                  >
                    <span class="fs-small">انتخاب آدرس</span>
                    <v-icon>mdi-square-edit-outline</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>

            <!-- dialgos select address -->
            <v-dialog
              v-model="dialogAddres"
              :width="$vuetify.breakpoint.mdAndUp ? '800px' : '340px'"
              class="modal_select_address"
            >
              <v-card class="card_modals">
                <v-card-title
                  class="white shopPrimary--text d-flex justify-content-between"
                >
                  <span class="fs-small"> انتخاب آدرس </span>
                  <span>
                    <v-icon
                      class="shopPrimary--text fs-small"
                      @click="handelOpenModal()"
                      >mdi-close</v-icon
                    >
                  </span>
                </v-card-title>
                <hr />
                <v-card-text>
                  <v-row justify="start">
                    <v-col xl="3" lg="3" md="3" sm="4" xs="4" cols="12">
                      <v-btn
                        variant="text"
                        block
                        class="purple-borderedBtn"
                        @click="dialogaddaddress = true"
                        append-icon=""
                      >
                        افزودن آدرس جدید
                      </v-btn>
                    </v-col>
                  </v-row>
                  <hr />

                  لطفا آدرس مورد نظر خود را انتخاب کنید یا ویرایش کنید.
                  <hr />
                  <v-col
                    xl="12"
                    lg="12"
                    md="12"
                    sm="12"
                    xs="12"
                    cols="12"
                    class="py-0"
                    :style="
                      selectedAddress.id == item.id
                        ? 'background-color: #e2c7ff ; border-radius:8px ;font-weight:400;'
                        : ''
                    "
                    v-for="(item, index) in addressesList"
                    :key="index"
                    @click="selectAddress(item)"
                  >
                    <div class="box-selected-address">
                      <v-col xl="12" lg="12" md="12" sm="12" xs="12" cols="12">
                        <div class="items_addres_box">
                          <Radio
                            name="address"
                            label=""
                            :id="item.id"
                            :value="item.id"
                            v-bind:inverted="true"
                            v-bind:checked="
                              selectedAddress.id == item.id ? true : false
                            "
                            v-bind:required="true"
                            class="radio_address"
                          ></Radio>

                          <div class="details_addres_box">
                            <h6 class="fs-small font-weight-bold">
                              {{ item.stateName }} ,
                            </h6>
                          </div>
                          <div class="details_addres_box">
                            <h6 class="fs-small font-weight-bold">
                              {{ item.cityName }} ,
                            </h6>
                          </div>
                          <div
                            class="details_addres_box"
                            v-if="selectedAddress.district"
                          >
                            <h6 class="fs-small font-weight-bold">
                              {{ item.district }} منطقه
                            </h6>
                          </div>
                          <div class="details_addres_box">
                            <h6 class="fs-small font-weight-bold">
                              {{ item.address }}
                            </h6>
                          </div>
                        </div>
                      </v-col>

                      <v-col xl="12" lg="12" md="12" sm="12" xs="12" cols="12">
                        <div class="d-flex align-center">
                          <v-icon color="primary">mdi-account-outline</v-icon>
                          <h6 class="fs-small font-weight-bold ml-2 pt-1">
                            نام گیرنده:
                          </h6>
                          <h5 class="fs-small font-weight-bold pt-1">
                            {{ item.name }}
                          </h5>
                        </div>
                      </v-col>

                      <v-col xl="12" lg="12" md="12" sm="12" xs="12" cols="12">
                        <div class="d-flex align-center">
                          <v-icon color="primary">mdi-cellphone</v-icon>
                          <h6 class="fs-small font-weight-bold ml-2 pt-1">
                            موبایل گیرنده:
                          </h6>
                          <h5 class="fs-small font-weight-bold pt-1">
                            {{ item.mobile }}
                          </h5>
                        </div>
                      </v-col>

                      <v-col xl="12" lg="12" md="12" sm="12" xs="12" cols="12">
                        <div class="d-flex align-center">
                          <v-icon color="primary" class="pb-2"
                            >mdi-email</v-icon
                          >
                          <h6 class="fs-small font-weight-bold ml-2">
                            کد پستی:
                          </h6>
                          <h5 class="fs-small font-weight-bold">
                            {{ item.postalCode }}
                          </h5>
                        </div>
                      </v-col>
                      <v-row justify="end">
                        <v-col xl="2" lg="2" md="2" sm="4" xs="12" cols="12">
                          <v-btn
                            outlined
                            block
                            color="primary"
                            class="d-flex justify-space-between"
                            @click="editAddress(item)"
                            append-icon="mdi-chevron-left"
                          >
                            ویرایش
                            <v-icon>mdi-chevron-left</v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </div>
                    <hr v-if="addressesList && addressesList.length" />
                  </v-col>
                </v-card-text>
              </v-card>
            </v-dialog>

            <!-- dialog  Add address -->
            <v-dialog
              v-model="dialogaddaddress"
              :width="$vuetify.breakpoint.mdAndUp ? '800px' : '350px'"
              class="add-address_modal"
            >
              <v-card class="card_modals">
                <v-card-title
                  class="white shopPrimary--text d-flex justify-content-between"
                >
                  <span class="fs-small"> افزودن آدرس </span>
                  <span>
                    <v-icon
                      class="shopPrimary--text fs-small"
                      @click="dialogaddaddress = false"
                      >mdi-close</v-icon
                    >
                  </span>
                </v-card-title>
                <hr />
                <v-col cols="12" class="py-0">
                  <div class="help-text-modal">
                    <span>لطفا اطلاعات را به فارسی وارد کنید</span>
                  </div>
                </v-col>
                <form @submit.prevent="submit">
                  <div class="line-response_item">
                    <v-col cols="12">
                      <v-text-field
                        v-model="newAddress.addressTitle"
                        outlined
                        dense
                        hide-details
                        label=" عنوان آدرس"
                        placeholder="مانند : منزل، محل‌کار و …"
                      ></v-text-field>
                    </v-col>

                    <v-col xl="6" lg="6" md="6" sm="12" xs="12" cols="12">
                      <v-text-field
                        v-model="newAddress.name"
                        outlined
                        dense
                        hide-details
                        label="نام گیرنده"
                        @input="checkPersian(newAddress.name, 'name')"
                      ></v-text-field>
                    </v-col>
                    <v-col xl="6" lg="6" md="6" sm="12" xs="12" cols="12">
                      <v-text-field
                        v-model="newAddress.mobile"
                        pattern="\d*"
                        outlined
                        dense
                        hide-details
                        label="موبایل گیرنده"
                      ></v-text-field>
                      <span
                        class="red--text text-right mb-3 pt-0 mt-0"
                        v-if="
                          newAddress.mobile &&
                          !validateMobileNumber(newAddress.mobile)
                        "
                        >شماره موبایل وارد شده صحیح نمی‌باشد.</span
                      >
                    </v-col>
                  </div>
                  <div class="line-response_item">
                    <v-col xl="6" lg="6" md="6" sm="12" xs="12" cols="12">
                      <v-select
                        :items="states"
                        v-model="newAddress.stateId"
                        outlined
                        dense
                        variant="solo"
                        menu-icon="mdi-menu-down"
                        item-text="name"
                        item-value="id"
                        v-on:change="updateCity('newAddress')"
                        hide-details
                        label="استان"
                      >
                        <template v-slot:append>
                          <v-icon>$ArrowDown</v-icon>
                        </template>
                      </v-select>
                    </v-col>
                    <v-col xl="6" lg="6" md="6" sm="12" xs="12" cols="12">
                      <v-select
                        outlined
                        dense
                        :items="cities"
                        v-model="newAddress.city"
                        :rules="cityRules"
                        required
                        :loading="gettingCitiesLoading"
                        item-text="name"
                        item-value="id"
                        return-object
                        hide-details
                        label="شهر"
                        @change="cityLog(editingAddress.city)"
                      >
                        <template v-slot:append>
                          <v-icon>$ArrowDown</v-icon>
                        </template>
                      </v-select>
                    </v-col>
                  </div>
                  <span v-show="false">{{ reactivity }}</span>
                  <div
                    class="line-response_item align-center"
                    v-if="newAddress.city && newAddress.city.name === 'تهران'"
                  >
                    <v-col xl="6" lg="6" md="6" sm="12" xs="12" cols="12">
                      <v-select
                        dense
                        outlined
                        hide-details
                        label="منطقه"
                        :items="districts"
                        v-model="newAddress.district"
                        item-value="id"
                        item-text="name"
                        :rules="areaRules"
                      >
                        <template v-slot:append>
                          <v-icon>$ArrowDown</v-icon>
                        </template>
                      </v-select>
                    </v-col>
                    <v-col xl="6" lg="6" md="6" sm="12" xs="12" cols="12">
                      <v-text-field
                        outlined
                        dense
                        hide-details
                        label=" کد پستی"
                        v-model="newAddress.postalCode"
                        type="number"
                      >
                      </v-text-field>
                    </v-col>
                  </div>

                  <div class="line-response_item align-center">
                    <v-col
                      xl="12"
                      lg="12"
                      md="12"
                      sm="12"
                      xs="12"
                      cols="12"
                      v-if="newAddress.city && newAddress.city.name !== 'تهران'"
                    >
                      <v-text-field
                        outlined
                        dense
                        hide-details
                        label=" کد پستی"
                        v-model="newAddress.postalCode"
                        type="number"
                      ></v-text-field>
                    </v-col>
                  </div>
                  <div class="line-response_item align-center">
                    <v-col xl="12" lg="12" md="12" sm="12" xs="12" cols="12">
                      <v-textarea
                        rows="3"
                        row-height="20"
                        auto-grow
                        outlined
                        dense
                        v-model="newAddress.address"
                        :rules="daddressesRules"
                        label="آدرس"
                        @input="checkPersian(newAddress.address, 'address')"
                      ></v-textarea>
                    </v-col>
                  </div>
                  <div class="line-response_item">
                    <v-col
                      md="8"
                      xl="8"
                      lg="8"
                      sm="6"
                      xs="6"
                      cols="12"
                      class="p-0 m-0"
                    ></v-col>
                    <v-col
                      md="4"
                      xl="4"
                      lg="4"
                      sm="6"
                      xs="6"
                      cols="12"
                      class="d-flex justify-content-end"
                    >
                      <v-btn
                        class="shopPrimary white--text ml-2"
                        type="submit"
                        :disabled="
                          !newAddress.address ||
                          !newAddress.addressTitle ||
                          !newAddress.name ||
                          !newAddress.stateId ||
                          !newAddress.postalCode ||
                          !newAddress.city ||
                          !newAddress.mobile ||
                          !validateMobileNumber(newAddress.mobile)
                        "
                        @click="addAddress()"
                        :loading="loading2"
                      >
                        ثبت
                      </v-btn>
                      <v-btn
                        class="purple-borderedBtn"
                        @click="dialogaddaddress = false"
                        >بستن
                      </v-btn>
                    </v-col>
                  </div>
                </form>
              </v-card>
            </v-dialog>

            <!-- dialog Edit Address -->
            <v-dialog
              v-model="dialogEditAddress"
              :width="$vuetify.breakpoint.mdAndUp ? '800px' : '350px'"
            >
              <v-card class="card_modals">
                <v-card-title
                  class="white shopPrimary--text d-flex justify-content-between"
                >
                  <span class="shopPrimary--text fs-medium"> ویرایش آدرس </span>
                  <span>
                    <v-icon
                      class="shopPrimary--text fs-medium"
                      @click="dialogEditAddress = false"
                      >mdi-close</v-icon
                    >
                  </span>
                </v-card-title>
                <hr />
                <form @submit.prevent="submit">
                  <div class="line-response_item">
                    <v-col cols="12">
                      <v-text-field
                        outlined
                        dense
                        hide-details
                        placeholder=" عنوان آدرس"
                        v-model="editingAddress.addressTitle"
                      >
                      </v-text-field>
                    </v-col>

                    <v-col xl="6" lg="6" md="6" sm="12" xs="12">
                      <v-text-field
                        outlined
                        dense
                        hide-details
                        placeholder="نام گیرنده "
                        v-model="editingAddress.name"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col xl="6" lg="6" md="6" sm="12" xs="12">
                      <v-text-field
                        v-model="editingAddress.mobile"
                        pattern="\d*"
                        outlined
                        dense
                        hide-details
                        placeholder="موبایل گیرنده"
                      ></v-text-field>
                      <span
                        class="red--text text-right mb-3 pt-0 mt-0"
                        v-if="
                          editingAddress.mobile &&
                          editingAddress.mobile != '-' &&
                          editingAddress.mobile.length &&
                          !validateMobileNumber(editingAddress.mobile)
                        "
                        >شماره موبایل وارد شده صحیح نمی‌باشد.</span
                      >
                    </v-col>
                  </div>

                  <div class="line-response_item">
                    <v-col xl="6" lg="6" md="6" sm="12" xs="12">
                      <v-select
                        dense
                        outlined
                        hide-details
                        placeholder="استان"
                        :items="states"
                        v-model="editingAddress.stateId"
                        item-value="id"
                        item-text="name"
                        @change="updateCity('editAddress')"
                      >
                        <template v-slot:append>
                          <v-icon>$ArrowDown</v-icon>
                        </template>
                      </v-select>
                    </v-col>
                    <v-col xl="6" lg="6" md="6" sm="12" xs="12">
                      <v-select
                        dense
                        outlined
                        hide-details
                        placeholder="شهر"
                        :items="cities"
                        v-model="editingAddress.city"
                        item-value="id"
                        item-text="name"
                        :rules="cityRules"
                        :loading="gettingCitiesLoading"
                        return-object
                        @change="cityLog(editingAddress.city)"
                      >
                        <template v-slot:append>
                          <v-icon>$ArrowDown</v-icon>
                        </template>
                      </v-select>
                    </v-col>
                  </div>

                  <span v-show="false">{{ reactivity }}</span>
                  <div
                    class="line-response_item"
                    v-if="
                      editingAddress.city && editingAddress.city.name == 'تهران'
                    "
                  >
                    <v-col xl="6" lg="6" md="6" sm="12" xs="12">
                      <v-select
                        dense
                        outlined
                        hide-details
                        placeholder="منطقه"
                        :items="districts"
                        v-model="editingAddress.district"
                        :rules="areaRules"
                        item-value="id"
                        item-text="name"
                      >
                        <template v-slot:append>
                          <v-icon>$ArrowDown</v-icon>
                        </template>
                      </v-select>
                    </v-col>

                    <v-col xl="6" lg="6" md="6" sm="12" xs="12">
                      <v-text-field
                        outlined
                        dense
                        hide-details
                        placeholder=" کد پستی"
                        v-model="editingAddress.postalCode"
                        pattern="\d*"
                      >
                      </v-text-field>
                    </v-col>
                  </div>

                  <div class="line-response_item">
                    <v-col
                      xl="12"
                      lg="12"
                      md="12"
                      sm="12"
                      xs="12"
                      v-if="
                        editingAddress.city &&
                        editingAddress.city.name !== 'تهران'
                      "
                    >
                      <v-text-field
                        outlined
                        dense
                        hide-details
                        placeholder=" کد پستی"
                        v-model="editingAddress.postalCode"
                        pattern="\d*"
                      >
                      </v-text-field>
                    </v-col>
                  </div>

                  <div class="line-response_item">
                    <v-col xl="12" lg="12" md="12" sm="12" xs="12">
                      <v-textarea
                        outlined
                        dense
                        v-model="editingAddress.address"
                        :rules="daddressesRules"
                        label="آدرس"
                        rows="3"
                        row-height="20"
                        auto-grow
                      >
                      </v-textarea>
                    </v-col>
                  </div>

                  <div class="line-response_item">
                    <v-col
                      md="8"
                      xl="8"
                      lg="8"
                      sm="6"
                      xs="6"
                      class="p-0 m-0"
                    ></v-col>
                    <v-col
                      md="4"
                      xl="4"
                      lg="4"
                      sm="6"
                      xs="6"
                      class="d-flex justify-content-end"
                    >
                      <v-btn
                        class="shopPrimary white--text ml-2"
                        @click="editUseraddress()"
                        :disabled="
                          !editingAddress.address ||
                          !editingAddress.addressTitle ||
                          !editingAddress.name ||
                          !editingAddress.stateId ||
                          !editingAddress.postalCode ||
                          !editingAddress.city ||
                          !editingAddress.mobile ||
                          !validateMobileNumber(editingAddress.mobile)
                        "
                      >
                        ویرایش آدرس
                      </v-btn>
                      <v-btn
                        class="purple-borderedBtn"
                        @click="dialogEditAddress = false"
                        >بستن
                      </v-btn>
                    </v-col>
                  </div>
                </form>
              </v-card>
            </v-dialog>
          </div>
        </v-col>
        <v-col
          xl="12"
          lg="12"
          md="12"
          sm="12"
          xs="12"
          cols="12"
          class="p-0 my-2"
        >
          <v-card class="common-card-log">
            <v-col xl="12" lg="12" md="12" sm="12" xs="12">
              <h5 class="fontSizemedium font-weight-bold mainFont--text">
                انتخاب روش پرداخت
              </h5>
            </v-col>

            <div class="items_type_payment">
              <v-col xl="8" lg="8" md="12" sm="12" xs="12" cols="12">
                <div class="btn_radio_Payment">
                  <div @click="handleradioinstallment('first')" class="d-flex">
                    <div
                      style="
                        width: 20px;
                        height: 20px;
                        border-radius: 50%;
                        border: 2px solid #7c4dff;
                      "
                      class="mt-1 text-center align-center d-flex justify-center"
                    >
                      <div
                        v-if="!installment"
                        style="width: 12px; height: 12px; border-radius: 50%"
                        class="primary"
                      ></div>
                    </div>
                    <span
                      :class="[
                        !installment ? 'font-weight-bold' : '',
                        'pointer fontSizemedium pr-2',
                      ]"
                      >پرداخت کامل</span
                    >
                  </div>
                </div>
              </v-col>
              <v-col xl="4" lg="4" md="12" sm="12" xs="12" cols="12">
                <v-btn
                  block
                  class="purple-mainBtn d-flex justify-space-between"
                  @click="fullPaymentDialog = true"
                  height="44"
                >
                  <span class="fontSizesmall"> راهنمای پرداخت کامل </span>

                  <v-icon>mdi-credit-card</v-icon>
                </v-btn>
              </v-col>
            </div>

            <div class="items_type_payment">
              <v-col xl="8" lg="8" md="12" sm="12" xs="12" cols="12">
                <div class="btn_radio_Payment">
                  <div @click="handleradioinstallment('second')" class="d-flex">
                    <div
                      style="
                        width: 20px;
                        height: 20px;
                        border-radius: 50%;
                        border: 2px solid #7c4dff;
                      "
                      class="mt-1 text-center align-center d-flex justify-center"
                    >
                      <div
                        v-if="installment"
                        style="width: 12px; height: 12px; border-radius: 50%"
                        class="primary"
                      ></div>
                    </div>
                    <span
                      :class="[
                        installment ? 'font-weight-bold' : '',
                        'pointer fontSizemedium pr-2',
                      ]"
                    >
                      پرداخت اقساطی (برای خرید بیشتر از
                      {{ (minimumPrice / 1000000).toFixed(1) }} میلیون تومان)
                    </span>
                  </div>
                </div>
              </v-col>
              <v-col xl="4" lg="4" md="12" sm="12" xs="12" cols="12">
                <v-btn
                  block
                  class="purple-borderedBtn d-flex justify-space-between"
                  @click="installmentsDialog = true"
                  height="44"
                >
                  <span class="fontSizesmall"> راهنمای پرداخت اقساطی </span>

                  <v-icon>mdi-cash</v-icon>
                </v-btn>
              </v-col>
            </div>

            <div class="details_type_payment" v-if="installment">
              <v-col xl="12" lg="12" md="12" sm="12" xs="12" class="py-0">
                <div class="items_form_select_pay">
                  <h5 class="fs-medium font-weight-bold mainFont--text">
                    نوع قسط‌ بندی
                  </h5>
                </div>
              </v-col>
              <v-col xl="8" lg="8" md="12" sm="12" xs="12">
                <v-select
                  v-model="select"
                  :items="installmentItemsTitle"
                  class="mt-4"
                  outlined
                  hide-details
                  dense
                  @change="calculateInterest(true)"
                ></v-select>
              </v-col>
              <!-- <v-col xl="8" lg="8" md="12" sm="12" xs="12">

                    <radio v-for="(item) in installmentItemsTitle" :key="item.id" :label="item.title" :value="id"
                      v-model="select" class="input_radio_select_items" @change="calculateInterest()">
                    </radio>

                  </v-col> -->

              <div
                class="details_type_payment"
                v-if="select && !interestLoading"
              >
                <v-col xl="8" lg="8" md="12" sm="12" xs="12">
                  <div class="items_form_select_pay">
                    <h6 class="fs-small font-weight-bold mainFont--text">
                      مبلغ پیش پرداخت:
                    </h6>
                    <span class="fs-medium font-weight-bold shopPrimary--text">
                      {{
                        Number(
                          installmentResponse.prepaymentAmount
                        ).toLocaleString()
                      }}
                      تومان
                    </span>
                  </div>
                </v-col>
                <v-col xl="8" lg="8" md="12" sm="12" xs="12">
                  <div class="items_form_select_pay">
                    <h6 class="fs-small font-weight-bold mainFont--text">
                      تعداد چک‌ ها:
                    </h6>
                    <span class="fs-medium font-weight-bold shopPrimary--text">
                      {{
                        Number(
                          installmentResponse.totalCheques
                        ).toLocaleString()
                      }}
                    </span>
                  </div>
                </v-col>
                <v-col xl="8" lg="8" md="12" sm="12" xs="12">
                  <div class="items_form_select_pay">
                    <h6 class="fs-small font-weight-bold mainFont--text">
                      تاریخ چک ها :
                    </h6>

                    <div v-if="installmentResponse.dueDates">
                      <div
                        v-for="(dueDate, index) in installmentResponse.dueDates"
                        :key="index"
                      >
                        <span
                          class="fs-medium font-weight-bold shopPrimary--text mb-1"
                        >
                          {{ dueDate }}
                        </span>
                      </div>
                    </div>

                    <h6 v-else>-</h6>
                  </div>
                </v-col>
                <v-col xl="8" lg="8" md="12" sm="12" xs="12" cols="12">
                  <div class="items_form_select_pay">
                    <h6 class="fs-small font-weight-bold mainFont--text">
                      مبلغ هر چک:
                    </h6>
                    <span class="fs-medium font-weight-bold shopPrimary--text">
                      {{
                        Number(
                          installmentResponse.costEachCheque
                        ).toLocaleString()
                      }}
                      تومان
                    </span>
                  </div>
                </v-col>
                <v-col xl="8" lg="8" md="12" sm="12" xs="12" cols="12">
                  <div class="items_form_select_pay">
                    <h6 class="fs-small font-weight-bold mainFont--text">
                      مبلغ کل اقساط پس از درصد افزوده:
                    </h6>
                    <span class="fs-medium font-weight-bold shopPrimary--text">
                      {{
                        Number(
                          installmentResponse.costWithInterest
                        ).toLocaleString()
                      }}
                      تومان
                    </span>
                  </div>
                </v-col>
                <v-col xl="8" lg="8" md="12" sm="12" xs="12">
                  <div class="items_form_select_pay">
                    <h6 class="fs-small font-weight-bold mainFont--text">
                      جمع مبلغ کالاها:
                    </h6>
                    <span class="fs-medium font-weight-bold shopPrimary--text">
                      {{
                        Number(installmentResponse.finalCost).toLocaleString()
                      }}
                      تومان
                    </span>
                  </div>
                </v-col>
              </div>
            </div>
          </v-card>
          <!-- dialog full -->
          <v-dialog
            v-model="fullPaymentDialog"
            :width="$vuetify.breakpoint.mdAndUp ? '800px' : '400px'"
            class="modal_Payment"
          >
            <v-card class="card_modals">
              <v-card-title
                class="white shopPrimary--text d-flex justify-content-between"
              >
                <span class="font-weight-bold fs-medium"
                  >راهنمای پرداخت کامل</span
                >

                <span>
                  <v-icon
                    class="shopPrimary--text fs-medium"
                    @click="fullPaymentDialog = false"
                    >mdi-close</v-icon
                  >
                </span>
              </v-card-title>
              <hr />
              <v-col xl="12" lg="12" md="12" sm="12" xs="12">
                <div class="img_modal_Payment">
                  <img src="../../../assets/images/paymentfull.svg" alt="" />
                </div>
              </v-col>

              <v-col xl="12" lg="12" md="12" sm="12" xs="12">
                <div class="content_modal_pay">
                  <h6 class="fs-small">
                    در خرید کامل، تمامی هزینه سبد خرید به صورت یکجا از شما
                    دریافت می‌شود. مبلغ قابل پرداخت برای هر سبد خرید، مجموعه
                    هزینه‌های اقلام سبد خرید و هزینه حمل نقل کالا را شامل
                    می‌شود. جزئیات این اطلاعات مالی، در کارت اطلاعات پرداخت در
                    جهت چپ صفحه، آورده شده‌اند. برای پرداخت این مبلغ، ابتدا باید
                    قوانین و مقررات سایت را مطالعه نموده و پذیرفته و سپس، گزینه
                    «پرداخت و ثبت سفارش»، واقع در پایان کارت اطلاعات پرداخت، را
                    انتخاب نمایید. پس از انتخاب این گزینه به درگاه پرداختی برای
                    ورود اطلاعات کارت بانکی خود و پرداخت آنلاین مبلغ مورد نظر،
                    وارد خواهید شد. پس از گرداخت موفقیت‌آمیز تمام مبلغ، سفارش
                    شما در سامانه ثبت شده و اقلام سبد خرید شما در اسرع وقت برای
                    شما ارسال خواهد شد. پیگیری وضعیت سفارش از طریق مراجعه به
                    صفحه «سفارش‌ها» در بخش «تنظیمات حساب کاربری» قابل انجام است.
                  </h6>
                </div>
              </v-col>
              <v-divider></v-divider>
              <v-col xl="12" lg="12" md="12" sm="12" xs="12">
                <v-card-actions class="footer_modal_pay">
                  <div
                    class="footer_modal_pay-r pointer green-mainBtn"
                    @click="fullPaymentDialog = false"
                  >
                    <span>فهمیدم!</span>
                  </div>
                </v-card-actions>
              </v-col>
            </v-card>
          </v-dialog>
          <!-- dialog installments -->
          <v-dialog
            v-model="installmentsDialog"
            :width="$vuetify.breakpoint.mdAndUp ? '800px' : '400px'"
            class="modal_Payment"
          >
            <v-card class="card_modals">
              <v-card-title
                class="white shopPrimary--text d-flex justify-content-between"
              >
                <span class="font-weight-bold fs-medium"
                  >راهنمای پرداخت اقساطی</span
                >

                <span>
                  <v-icon
                    class="shopPrimary--text fs-medium"
                    @click="installmentsDialog = false"
                    >mdi-close</v-icon
                  >
                </span>
              </v-card-title>

              <hr class="pb-0 mb-0" />
              <v-col xl="12" lg="12" md="12" sm="12" xs="12">
                <v-window v-model="step">
                  <v-window-item :value="1">
                    <v-col
                      xl="12"
                      lg="12"
                      md="12"
                      sm="12"
                      xs="12"
                      class="px-0 py-0"
                    >
                      <div class="img_modal_Payment">
                        <img src="../../../assets/images/one.svg" alt="" />
                      </div>
                    </v-col>
                    <v-col
                      xl="12"
                      lg="12"
                      md="12"
                      sm="12"
                      xs="12"
                      class="px-0 py-0"
                    >
                      <v-card-text class="content_modal_pay">
                        <h6>
                          در خرید قسطی، می‌توانید هزینه اقلام سبد خرید خود را در
                          چندین بخش (قسط) پرداخت نمایید. پرداخت نوع اقساطی تنها
                          برای سبدهای خرید با ارزش بیش از
                          {{ (minimumPrice / 1000000).toFixed(1) }} میلیون تومان
                          امکان‌پذیر بوده و از طریق چک صیادی صورت می‌گیرد. در
                          صورت انتخاب این نحوه پرداخت، باید نوع قسط‌بندی مورد
                          نظر خود را مشخص کنید. جدول اطلاعات مربوط به هر
                          قسط‌بندی به شرح زیر است:
                        </h6>
                      </v-card-text>
                    </v-col>
                  </v-window-item>

                  <v-window-item :value="2">
                    <v-card-text>
                      <v-col
                        xl="12"
                        lg="12"
                        md="12"
                        sm="12"
                        xs="12"
                        class="px-0 py-0"
                      >
                        <div class="img_modal_Payment">
                          <img src="../../../assets/images/one.svg" alt="" />
                        </div>
                      </v-col>
                      <v-col
                        xl="12"
                        lg="12"
                        md="12"
                        sm="12"
                        xs="12"
                        class="px-0 py-0"
                      >
                        <v-simple-table
                          v-if="$vuetify.breakpoint.mdAndUp"
                          show-empty
                          :items="guideList"
                          :headers="headers"
                          striped
                          hide-default-footer
                          no-data-text="no_results_text"
                          class="table_modal_payment"
                        >
                          <thead>
                            <tr>
                              <th
                                v-for="item in headers"
                                :key="item.index"
                                class="text-center"
                              >
                                {{ item.text }}
                              </th>
                            </tr>
                          </thead>

                          <tbody>
                            <tr v-for="(item, index) in guideList" :key="index">
                              <td class="text-center">
                                {{ index + 1 }}
                              </td>
                              <td class="text-center">{{ item.title }}</td>
                              <td class="text-center">
                                {{ item.interestRate }}
                              </td>
                              <td class="text-center">{{ item.duration }}</td>
                              <td class="text-center">
                                %{{ item.prepaymentRate }}
                              </td>
                              <td class="text-center">
                                {{ Number(item.minimumPrice).toLocaleString() }}
                                تومان
                              </td>
                            </tr>
                          </tbody>
                        </v-simple-table>
                        <div v-else>
                          <v-card
                            class="py-4 px-6 mb-2"
                            v-for="(item, index) in guideList"
                            :key="index"
                          >
                            <v-row class="justify-space-between">
                              <span class="font-weight-bold fs-small">
                                نوع قسط‌ بندی
                              </span>
                              <span class="fs-small">{{ item.title }}</span>
                            </v-row>
                            <v-divider></v-divider>
                            <v-row class="justify-space-between">
                              <span class="font-weight-bold fs-small">
                                درصد سود
                              </span>
                              <span class="fs-small"
                                >%{{ item.interestRate }}</span
                              >
                            </v-row>
                            <v-divider></v-divider>
                            <v-row class="justify-space-between">
                              <span class="font-weight-bold fs-small">
                                تعداد قسط
                              </span>
                              <span class="fs-small">{{ item.duration }}</span>
                            </v-row>
                            <v-divider></v-divider>
                            <v-row class="justify-space-between">
                              <span class="font-weight-bold fs-small">
                                درصد پیش پرداخت
                              </span>
                              <span class="fs-small">
                                %{{ item.prepaymentRate }}
                              </span>
                            </v-row>
                            <v-divider></v-divider>
                            <v-row class="justify-space-between">
                              <span class="font-weight-bold fs-small">
                                حداقل سبد خرید
                              </span>
                              <span class="fs-small">
                                {{ Number(item.minimumPrice).toLocaleString() }}
                                تومان
                              </span>
                            </v-row>
                          </v-card>
                        </div>
                      </v-col>
                    </v-card-text>
                  </v-window-item>
                  <v-window-item :value="3">
                    <v-col
                      xl="12"
                      lg="12"
                      md="12"
                      sm="12"
                      xs="12"
                      class="px-0 py-0"
                    >
                      <div class="img_check_Payment">
                        <img
                          src="../../../assets/images/finalchequ.png"
                          alt=""
                        />
                      </div>
                    </v-col>
                    <v-col
                      xl="12"
                      lg="12"
                      md="12"
                      sm="12"
                      xs="12"
                      class="px-0 py-0"
                    >
                      <v-card-text class="content_modal_pay">
                        <h6>
                          در صورت انتخاب پرداخت نوع قسطی و سپس، انتخاب تعداد
                          اقساط، اطلاعات مربوط به هر قسط در اختیار شما قرار
                          خواهد گرفت. برای تکمیل پرداخت قسطی، شما باید به تعداد
                          قسط‌های انتخابی خود و با ارقام مربوط به مبلغ هر قسط،
                          یک چک صیادی پر کنید. مبلغ هر قسط در پس از انتخاب تعداد
                          اقساط در اختیار شما قرار می‌گیرد. تاریخ هر قسط نیز، بر
                          اساس تاریخ کنونی و فواصل اقساط مشخص می‌شوند. اطلاعات
                          مورد نیاز برای بخش‌های «در وجه» و «شماره ملی» در تصویر
                          چک بالا آورده شده‌اند.
                        </h6>
                      </v-card-text>
                    </v-col>
                  </v-window-item>
                  <v-window-item :value="4">
                    <v-col
                      xl="12"
                      lg="12"
                      md="12"
                      sm="12"
                      xs="12"
                      class="px-0 py-0"
                    >
                      <div class="img_modal_Payment">
                        <img src="../../../assets/images/two.svg" alt="" />
                      </div>
                    </v-col>
                    <v-col
                      xl="12"
                      lg="12"
                      md="12"
                      sm="12"
                      xs="12"
                      class="px-0 py-0"
                    >
                      <v-card-text class="content_modal_pay">
                        <h6>
                          شما می‌توانید پس از ورود اطلاعات مورد نیاز در چک(های)
                          صیادی حقیقی خود، به کارت اطلاعات پرداخت سبد خرید خود،
                          واقع در سمت چپ صفحه مراجعه نمایید. در این کارت، مبلغ
                          پیش‌پرداخت، تعداد اقساط، مبلغ هر قسط و هزینه حمل و نقل
                          کالاهای سبد خرید، قابل مشاهده هستند. برای پرداخت
                          اقساطی، ابتدا باید از طریق گزینه «پرداخت و ثبت سفارش»
                          در پایان این کارت، مبلغ مشخص شده به عنوان پیش‌پرداخت
                          را به صورت پرداخت آنلاین و از طریق درگاه بانکی واریز
                          نمایید.
                        </h6>
                      </v-card-text>
                    </v-col>
                  </v-window-item>

                  <v-window-item :value="5">
                    <v-col
                      xl="12"
                      lg="12"
                      md="12"
                      sm="12"
                      xs="12"
                      class="px-0 py-0"
                    >
                      <div class="img_modal_Payment">
                        <img src="../../../assets/images/three.svg" alt="" />
                      </div>
                    </v-col>
                    <v-col
                      xl="12"
                      lg="12"
                      md="12"
                      sm="12"
                      xs="12"
                      class="px-0 py-0"
                    >
                      <v-card-text class="content_modal_pay">
                        <h6>
                          پس از واریز شدن مبلغ پیش‌پرداخت، سفارش شما ثبت شده و
                          در وضعیت در انتظار اعتبارسنجی مالی قرار خواهد گرفت.
                          برای دریافت اقلام سبد خرید، ابتدا باید چک(های) صیادی
                          خود را که اطلاعات آن‌ها را با الگوبرداری از نمونه چک
                          صیادی به هنگام پرداخت پر نموده‌اید، برای گیرنده‌ای با
                          اطلاعاتی به شرح زیر ارسال نمایید.» هم میشه: «پس از
                          واریز شدن مبلغ پیش‌پرداخت، سفارش شما ثبت شده و در
                          وضعیت در انتظار اعتبارسنجی مالی قرار خواهد گرفت. برای
                          دریافت اقلام سبد خرید، ابتدا باید چک(های) صیادی خود را
                          به آدرس و اطلاعات زیر ارسال نمایید.» نشانی ارسال:
                          تهران -میدان جمهوری- خ جمهوری- خ گلشن (طاهربهزاد) -خ
                          چنگیزی- نبش کوچه بوذر جمهری - پلاک ۲ (درب سبز رنگ) -
                          واحد ۱، کد پستی: ۱۳۱۸۶۳۴۶۵۳
                        </h6>
                      </v-card-text>
                    </v-col>
                  </v-window-item>
                </v-window>
              </v-col>
              <v-divider></v-divider>
              <v-col xl="12" lg="12" md="12" sm="12" xs="12">
                <v-card-actions class="footer_modal_pay">
                  <div
                    class="footer_modal_pay-r pointer purple-mainBtn"
                    v-if="step < 5"
                    @click="step++"
                  >
                    <span> مرحله بعدی</span>
                  </div>
                  <div
                    class="footer_modal_pay-r pointer green-mainBtn"
                    v-if="step == 5"
                    @click="
                      installmentsDialog = false;
                      step = 0;
                    "
                  >
                    <span>فهمیدم!</span>
                  </div>
                  <div
                    class="footer_modal_pay-l pointer red-mainBtn"
                    v-if="step > 1"
                    @click="step--"
                  >
                    <span>مرحله قبل</span>
                  </div>
                </v-card-actions>
              </v-col>
            </v-card>
          </v-dialog>

          <SidebrProcess
            v-show="false"
            v-if="installmentResponseShow"
            :installmentID="installmentResponse"
            :showTextpay="showTextpay"
          />
        </v-col>
      </v-col>

      <v-col xl="4" lg="4" md="5" sm="12" xs="12" class="py-0">
        <v-card class="common-card-log">
          <div v-if="!installment">
            <v-col xl="12" lg="12" md="12" sm="12" xs="12" class="px-0">
              <h4 class="fs-medium2 font-weight-bold mainFont--text">
                خرید نقدی
              </h4>
            </v-col>
            <v-col
              xl="12"
              lg="12"
              md="12"
              sm="12"
              xs="12"
              class="px-0"
              v-for="(item, index) in checkoutAnswer.details"
              :key="index"
            >
              <div class="text_content_Process">
                <v-col
                  xl="8"
                  lg="8"
                  md="12"
                  sm="8"
                  xs="8"
                  class="details_info_buy"
                >
                  <h6 class="fs-small font-weight-bold mainFont--text">
                    {{ item.details.name }}
                  </h6>
                </v-col>
                <v-col
                  xl="4"
                  lg="4"
                  md="12"
                  sm="4"
                  xs="4"
                  class="details_info_buy_l"
                >
                  <h6 class="fs-small font-weight-bold mainFont--text">
                    {{ Number(item.details.price).toLocaleString() }} تومان
                  </h6>
                </v-col>
              </div>
            </v-col>
            <v-col xl="12" lg="12" md="12" sm="12" xs="12" class="px-0">
              <div class="text_content_Process">
                <v-col
                  xl="8"
                  lg="8"
                  md="12"
                  sm="8"
                  xs="8"
                  class="details_info_buy"
                >
                  <h6 class="fs-small font-weight-bold mainFont--text">
                    جمع مبلغ کالاها:
                  </h6>
                </v-col>
                <v-col
                  xl="4"
                  lg="4"
                  md="12"
                  sm="4"
                  xs="4"
                  class="details_info_buy_l"
                >
                  <h6 class="fs-small font-weight-bold mainFont--text">
                    {{ Number(checkoutAnswer.totalCost).toLocaleString() }}
                    تومان
                  </h6>
                </v-col>
              </div>
            </v-col>
            <v-col xl="12" lg="12" md="12" sm="12" xs="12" class="px-0">
              <div class="text_content_Process">
                <v-col
                  xl="8"
                  lg="8"
                  md="12"
                  sm="8"
                  xs="8"
                  class="details_info_buy"
                >
                  <h6 class="fs-small font-weight-bold mainFont--text">
                    هزینه حمل و نقل:
                  </h6>
                </v-col>
                <v-col
                  xl="4"
                  lg="4"
                  md="12"
                  sm="4"
                  xs="4"
                  class="details_info_buy_l"
                >
                  <h6 class="fs-small font-weight-bold mainFont--text">
                    {{ Number(shippingCost).toLocaleString() }}
                    تومان
                  </h6>
                </v-col>
              </div>
            </v-col>
            <v-col xl="12" lg="12" md="12" sm="12" xs="12" class="px-0">
              <div class="text_content_Process">
                <v-col
                  xl="8"
                  lg="8"
                  md="12"
                  sm="8"
                  xs="8"
                  class="details_info_buy"
                >
                  <h5 class="fs-small font-weight-bold mainFont--text">
                    مبلغ قابل پرداخت:
                  </h5>
                </v-col>
                <v-col
                  xl="4"
                  lg="4"
                  md="12"
                  sm="4"
                  xs="4"
                  class="details_info_buy_l"
                >
                  <h5
                    v-if="shippingCost"
                    class="fs-small font-weight-bold mainFont--text"
                  >
                    {{ Number(computedFinalCost).toLocaleString() }}

                    تومان
                  </h5>
                </v-col>
              </div>
            </v-col>
            <v-col xl="12" lg="12" md="12" sm="12" xs="12" class="px-0">
              <div class="text_content_Process discount-text">
                <v-col
                  xl="8"
                  lg="8"
                  md="12"
                  sm="8"
                  xs="8"
                  class="details_info_buy"
                >
                  <h5 class="fs-small font-weight-bold">
                    سود شما از این خرید:
                  </h5>
                </v-col>
                <v-col
                  xl="4"
                  lg="4"
                  md="12"
                  sm="4"
                  xs="4"
                  class="details_info_buy_l"
                >
                  <h5 class="fs-small font-weight-bold">
                    {{ Number(checkoutAnswer.discount).toLocaleString() }}

                    تومان
                  </h5>
                </v-col>
              </div>
            </v-col>
            <v-col
              xl="12"
              lg="12"
              md="12"
              sm="12"
              xs="12"
              class="px-0"
              v-if="checkoutAnswer.discountVoucherUse"
            >
              <div class="text_content_Process discount-text">
                <v-col
                  xl="8"
                  lg="8"
                  md="12"
                  sm="8"
                  xs="8"
                  class="details_info_buy"
                >
                  <h5 class="fs-small font-weight-bold">اعتبار هدیه:</h5>
                </v-col>
                <v-col
                  xl="4"
                  lg="4"
                  md="12"
                  sm="4"
                  xs="4"
                  class="details_info_buy_l"
                >
                  <h5 class="fs-small font-weight-bold">
                    {{
                      Number(
                        checkoutAnswer.discountVoucherAmount
                      ).toLocaleString()
                    }}

                    تومان
                  </h5>
                </v-col>
              </div>
            </v-col>
          </div>

          <div v-if="installment">
            <v-col
              cols="12"
              xl="12"
              lg="12"
              md="12"
              sm="12"
              xs="12"
              class="px-0"
              v-if="installment"
            >
              <h4 class="fs-medium2 font-weight-bold mainFont--text">
                خرید اقساط:
              </h4>
            </v-col>

            <v-col xl="12" lg="12" md="12" sm="12" xs="12" class="px-0">
              <div class="text_content_Process">
                <v-col
                  xl="8"
                  lg="8"
                  md="12"
                  sm="8"
                  xs="8"
                  class="details_info_buy"
                >
                  <h6 class="fs-small font-weight-bold mainFont--text">
                    مبلغ پیش پرداخت:
                  </h6>
                </v-col>
                <v-col
                  xl="4"
                  lg="4"
                  md="12"
                  sm="4"
                  xs="4"
                  class="details_info_buy_l"
                >
                  <h6
                    v-if="installmentResponse.prepaymentAmount"
                    class="fs-small font-weight-bold mainFont--text"
                  >
                    {{
                      Number(
                        installmentResponse.prepaymentAmount
                      ).toLocaleString()
                    }}
                    تومان
                  </h6>
                  <h6 v-else>-</h6>
                </v-col>
              </div>
            </v-col>
            <v-col xl="12" lg="12" md="12" sm="12" xs="12" class="px-0">
              <div class="text_content_Process">
                <v-col
                  xl="8"
                  lg="8"
                  md="12"
                  sm="8"
                  xs="8"
                  class="details_info_buy"
                >
                  <h6 class="fs-small font-weight-bold mainFont--text">
                    تعداد چک :
                  </h6>
                </v-col>
                <v-col
                  xl="4"
                  lg="4"
                  md="12"
                  sm="4"
                  xs="4"
                  class="details_info_buy_l"
                >
                  <h6
                    v-if="installmentResponse.totalCheques"
                    class="fs-small font-weight-bold mainFont--text"
                  >
                    {{
                      Number(installmentResponse.totalCheques).toLocaleString()
                    }}
                  </h6>
                  <h6 v-else>-</h6>
                </v-col>
              </div>
            </v-col>
            <v-col xl="12" lg="12" md="12" sm="12" xs="12" class="px-0">
              <div class="text_content_Process">
                <v-col
                  xl="8"
                  lg="8"
                  md="12"
                  sm="8"
                  xs="8"
                  class="details_info_buy"
                >
                  <h6 class="fs-small font-weight-bold mainFont--text">
                    مبلغ هر چک:
                  </h6>
                </v-col>
                <v-col
                  xl="4"
                  lg="4"
                  md="12"
                  sm="4"
                  xs="4"
                  class="details_info_buy_l"
                >
                  <h6
                    v-if="installmentResponse.costEachCheque"
                    class="fs-small font-weight-bold mainFont--text"
                  >
                    {{
                      Number(
                        installmentResponse.costEachCheque
                      ).toLocaleString()
                    }}
                    تومان
                  </h6>
                  <h6 v-else>-</h6>
                </v-col>
              </div>
            </v-col>
            <v-col xl="12" lg="12" md="12" sm="12" xs="12" class="px-0">
              <div class="text_content_Process">
                <v-col
                  xl="8"
                  lg="8"
                  md="12"
                  sm="8"
                  xs="8"
                  class="details_info_buy"
                >
                  <h6 class="fs-small font-weight-bold mainFont--text">
                    مبلغ کل اقساط پس از درصد افزوده:
                  </h6>
                </v-col>
                <v-col
                  xl="4"
                  lg="4"
                  md="12"
                  sm="4"
                  xs="4"
                  class="details_info_buy_l"
                >
                  <h6
                    v-if="installmentResponse.costWithInterest"
                    class="fs-small font-weight-bold mainFont--text"
                  >
                    {{
                      Number(
                        installmentResponse.costWithInterest
                      ).toLocaleString()
                    }}
                    تومان
                  </h6>
                  <h6 v-else>-</h6>
                </v-col>
              </div>
            </v-col>
            <v-col xl="12" lg="12" md="12" sm="12" xs="12" class="px-0">
              <div class="text_content_Process">
                <v-col
                  xl="8"
                  lg="8"
                  md="12"
                  sm="8"
                  xs="8"
                  class="details_info_buy"
                >
                  <h6 class="fs-small font-weight-bold mainFont--text">
                    هزینه حمل و نقل:
                  </h6>
                </v-col>
                <v-col
                  xl="4"
                  lg="4"
                  md="12"
                  sm="4"
                  xs="4"
                  class="details_info_buy_l"
                >
                  <h6 class="fs-small font-weight-bold mainFont--text">
                    {{ Number(shippingCost).toLocaleString() }}
                    تومان
                  </h6>
                </v-col>
              </div>
            </v-col>
            <v-col xl="12" lg="12" md="12" sm="12" xs="12" class="px-0">
              <div class="text_content_Process">
                <v-col
                  xl="8"
                  lg="8"
                  md="12"
                  sm="8"
                  xs="8"
                  class="details_info_buy"
                >
                  <h6 class="fs-small font-weight-bold mainFont--text">
                    جمع مبلغ کالاها:
                  </h6>
                </v-col>
                <v-col
                  xl="4"
                  lg="4"
                  md="12"
                  sm="4"
                  xs="4"
                  class="details_info_buy_l"
                >
                  <h6
                    v-if="installmentResponse.finalItemsCost"
                    class="fs-small font-weight-bold mainFont--text"
                  >
                    {{
                      Number(
                        installmentResponse.finalItemsCost
                      ).toLocaleString()
                    }}
                    تومان
                  </h6>
                  <h6 v-else>-</h6>
                </v-col>
              </div>
            </v-col>
            <v-col xl="12" lg="12" md="12" sm="12" xs="12" class="px-0">
              <div class="text_content_Process discount-text">
                <v-col
                  xl="8"
                  lg="8"
                  md="12"
                  sm="8"
                  xs="8"
                  class="details_info_buy"
                >
                  <h5 class="fs-small font-weight-bold">
                    سود شما از این خرید:
                  </h5>
                </v-col>
                <v-col
                  xl="4"
                  lg="4"
                  md="12"
                  sm="4"
                  xs="4"
                  class="details_info_buy_l"
                >
                  <h5 class="fs-small font-weight-bold">
                    {{ Number(checkoutAnswer.discount).toLocaleString() }}

                    تومان
                  </h5>
                </v-col>
              </div>
            </v-col>
            <v-col
              xl="12"
              lg="12"
              md="12"
              sm="12"
              xs="12"
              class="px-0"
              v-if="checkoutAnswer.discountVoucherUse"
            >
              <div class="text_content_Process discount-text">
                <v-col
                  xl="8"
                  lg="8"
                  md="12"
                  sm="8"
                  xs="8"
                  class="details_info_buy"
                >
                  <h5 class="fs-small font-weight-bold">اعتبار هدیه:</h5>
                </v-col>
                <v-col
                  xl="4"
                  lg="4"
                  md="12"
                  sm="4"
                  xs="4"
                  class="details_info_buy_l"
                >
                  <h5 class="fs-small font-weight-bold">
                    {{
                      Number(
                        checkoutAnswer.discountVoucherAmount
                      ).toLocaleString()
                    }}

                    تومان
                  </h5>
                </v-col>
              </div>
            </v-col>
            <v-col xl="12" lg="12" md="12" sm="12" xs="12" class="px-0">
              <div class="text_content_Process">
                <v-col
                  xl="8"
                  lg="8"
                  md="12"
                  sm="8"
                  xs="8"
                  class="details_info_buy"
                >
                  <h5 class="fs-small font-weight-bold mainFont--text">
                    مبلغ نهایی:
                  </h5>
                </v-col>
                <v-col
                  xl="4"
                  lg="4"
                  md="12"
                  sm="4"
                  xs="4"
                  class="details_info_buy_l"
                >
                  <h5
                    class="fs-small font-weight-bold mainFont--text"
                    v-if="installmentResponse.finalCost"
                  >
                    {{ Number(installmentResponse.finalCost).toLocaleString() }}
                    تومان
                  </h5>
                  <h5 v-else>-</h5>
                </v-col>
              </div>
            </v-col>
          </div>

          <v-col xl="12" lg="12" md="12" sm="12" xs="12" cols="12" class="px-0">
            <h5 class="fs-small font-weight-bold mainFont--text">
              پرداخت امن زرین پال
            </h5>
          </v-col>
          <v-col xl="12" lg="12" md="12" sm="12" xs="12" cols="12" class="px-0">
            <h5 class="fs-small font-weight-bold mainFont--text">
              پرداخت امن به وسیله کلیه کارت‌های عضو شتاب از طریق درگاه زرین پال
            </h5>
          </v-col>
          <v-col xl="12" lg="12" md="12" sm="12" xs="12" cols="12" class="px-0">
            <div class="line_content_sidbarProcess"></div>
          </v-col>
          <v-col xl="12" lg="12" md="12" sm="12" xs="12" cols="12" class="px-0">
            <div class="text_content_Process">
              <h3 class="fs-small mainFont--text">
                اطلاعات شخصی شما برای پردازش شما و پشتیبانی از تجربه شما در این
                وبسایت و برای اهداف دیگری که در سیاست حفظ حریم خصوصی توضیح داده
                شده‌است استفاده می‌شود.
              </h3>
            </div>
          </v-col>
          <!--          rules modal-->
          <v-col xl="12" lg="12" md="12" sm="12" xs="12" cols="12" class="px-0">
            <div>
              <div class="align-center">
                <v-icon
                  v-if="!rules"
                  class="primary--text"
                  @click="rules = true"
                >
                  mdi-checkbox-blank-outline
                </v-icon>
                <v-icon
                  v-if="rules"
                  class="primary--text"
                  @click="rules = false"
                >
                  mdi-checkbox-marked-outline
                </v-icon>
                <span
                  class="primary--text font-weight-bold"
                  @click="rulesDialog = true"
                  style="cursor: pointer"
                >
                  شرایط و مقررات خرید از سایت را مطالعه نموده و می‌پذیرم
                </span>
              </div>
            </div>
          </v-col>
          <v-col xl="12" lg="12" md="12" sm="12" xs="12" cols="12">
            <v-btn
              class="purple-mainBtn"
              height="44"
              block
              type="submit"
              @click="finalize()"
              :disabled="buttonCheker()"
              :loading="loadingbtn"
            >
              <template v-slot:loader>
                <looping-rhombuses-spinner
                  :animation-duration="2500"
                  :rhombus-size="15"
                  color="#fff"
                  class="mx-auto my-10"
                />
              </template>
              پرداخت و ثبت سفارش
            </v-btn>
          </v-col>
        </v-card>
      </v-col>
      <v-dialog
        v-model="rulesDialog"
        :width="$vuetify.breakpoint.mdAndUp ? '800px' : '350px'"
      >
        <v-card class="card_modals">
          <v-card-title
            class="white shopPrimary--text d-flex justify-content-between"
          >
            <span class="font-weight-bold fs-medium"> قوانین و مقررات </span>

            <span>
              <v-icon
                class="shopPrimary--text fs-medium"
                @click="rulesDialog = false"
                >mdi-close</v-icon
              >
            </span>
          </v-card-title>
          <hr class="mb-0" />
          <v-card-text>
            <v-col xl="12" lg="12" md="12" sm="12" xs="12">
              <div class="items-rules">
                <div class="icon_number_rule">
                  <h1>1</h1>
                </div>

                <h5 class="mainFont--text">
                  کتاب‌های چاپی بدون عیب و نقص ظاهری، بسته بندی و برای مشتری
                  ارسال خواهند شد.
                </h5>
              </div>
            </v-col>
            <v-col xl="12" lg="12" md="12" sm="12" xs="12">
              <div class="items-rules">
                <div class="icon_number_rule">
                  <h1>2</h1>
                </div>

                <h5 class="mainFont--text">
                  در هنگام خرید دقت بفرمایید که باید سال چاپ را مدنظر قرار دهید.
                </h5>
              </div>
            </v-col>
            <v-col xl="12" lg="12" md="12" sm="12" xs="12">
              <div class="items-rule">
                <div class="icon_number_rule"></div>

                <h5>به خاطر سال چاپ متفاوت مرجوعی نخواهیم داشت.</h5>
              </div>
            </v-col>
            <v-col xl="12" lg="12" md="12" sm="12" xs="12">
              <div class="items-rules">
                <div class="icon_number_rule">
                  <h1>3</h1>
                </div>
                <h5 class="mainFont--text">
                  سال چاپ، تعداد صفحات، نویسنده کتاب‌ها، همواره بروز هستند و
                  می‌توانید در هنگام خرید آن‌ها را مد نظر قرار دهید.
                </h5>
              </div>
            </v-col>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>
<script>
import SidbarProcess from "./SidbarProcess";
import Radio from "./Components/AppRadio/AppRadio";
import Axios from "axios";
import Checkbox from "./Components/Checkbox/index";
import { LoopingRhombusesSpinner } from "epic-spinners";
import { isEmpty } from "ramda";

export default {
  name: "PurchaseProcess",
  components: { SidbarProcess, Radio, Checkbox, LoopingRhombusesSpinner },

  data: () => ({
    loading2: false,
    step: 1,
    radioValue: "first",
    rulesDialog: false,
    fullPaymentDialog: false,
    installmentsDialog: false,
    interestLoading: false,
    payment: "",
    cost: "",
    installmentResponseShow: false,
    installment: false,
    installmentItems: [],
    installmentItemsTitle: [],
    guideList: [],
    select: "",
    cartId: "",
    invoiceCode: "",
    showTextpay: false,
    installmentResponse: {},
    installmentPayment: {},
    minimumPrice: 0,
    headers: [
      { value: "index", text: "ردیف", sortable: false },
      { value: "title", text: "نوع قسط‌ بندی", sortable: false },
      { value: "interestRate", text: " درصد سود", sortable: false },
      { value: "duration", text: "تعداد قسط", sortable: false },
      { value: "prepaymentRate", text: "درصد پیش پرداخت", sortable: false },
      { value: "minimumPrice", text: "حداقل سبد خرید", sortable: false },
    ],
    items: [
      {
        text: "سبد خرید",
        disabled: false,
        href: "/checkout/cart",
      },
      {
        text: "تکمیل فرایند خرید",
        disabled: false,
        href: "",
      },
    ],

    shippingAddress: [],
    selectedAddress: {},
    addressesList: [],
    dialogAddres: false,
    dialogaddaddress: false,
    dialogEditAddress: false,
    address: "",
    state: "",
    city: "",
    area: "",
    code: "",
    addresses: "",
    finalCost: "",
    names: "",
    states: [],
    cities: [],
    districts: [],
    newAddress: {},
    editAddresses: [],
    shippingLoading: false,
    gettingCitiesLoading: false,
    editingAddress: {},
    isUserAddressCompleted: false,
    reactivity: false,
    loadingbtn: false,
    nameRules: [
      (value) => {
        if (value) return true;

        return "لطفا نام خود را وارد کنید";
      },
    ],

    daddressesRules: [
      (value) => {
        if (value) return true;

        return "لطفا آدرس  خود را وارد کنید";
      },
    ],
    codeRules: [
      (value) => {
        if (value) return true;

        return "لطفا  کد پستی خود را وارد کنید";
      },
    ],
    areaRules: [
      (value) => {
        if (value) return true;

        return "لطفا نام منطقه خود را وارد کنید";
      },
    ],
    stateRules: [
      (value) => {
        if (value) return true;

        return "لطفا نام استان خود را وارد کنید";
      },
    ],
    cityRules: [
      (value) => {
        if (value) return true;

        return "لطفا نام شهر خود را وارد کنید";
      },
    ],
    installmentPaymentId: "",
    rules: false,
    checkoutAnswer: {},
    shippingCost: "",
    isInstallment: false,
    userHasName: true,
    userName: "",
  }),

  methods: {
    convertNumbers2English(string) {
      try {
        let myString = String(string);
        myString = myString
          .replaceAll(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d))
          .replaceAll(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d))
          .replaceAll(/\D/g, "");
        return myString;
      } catch (error) {
        return "";
      }
    },
    validateMobileNumber(mobile) {
      const pattern = /^(?:\+98|0)?9\d{9}$/;
      return pattern.test(mobile);
    },
    checkPersian(input, field) {
      const persianRegex = /^[\u0600-\u06FF\s]+$/;
      if (!persianRegex.test(input)) {
        this.newAddress[field] = input.replace(/[^\u0600-\u06FF\s]/g, "");
      }
    },
    buttonCheker() {
      if (
        !this.rules ||
        isEmpty(this.addressesList) ||
        !this.selectedAddress ||
        !this.userHasName
      )
        return true;
      return false;
    },
    cityLog(i) {
      this.reactivity = !this.reactivity;
      this.editingAddress.city = { name: i.name, id: i.id };
    },
    handleradioinstallment(value) {
      if (value === "second") {
        if (this.checkoutAnswer.totalCost > 1000000) {
          this.installment = true;
          if (this.select) this.calculateInterest(true);
          this.showTextpay = true;
          this.isInstallment = true;
        } else {
          this.toast(
            "پرداخت اقساطی فقط برای خرید بیشتر از 1 میلیون تومان فعال می باشد.",
            "error"
          );
        }
      } else if (value === "first") {
        this.installment = false;
        this.installmentResponse = false;
        this.showTextpay = false;
        this.isInstallment = false;
        this.calculateInterest(false);
      } /*else {
        this.installment = false;
        this.emitter.emit("installmentResponse", false);
        this.showTextpay = false;
      }*/
    },
    getInstallment() {
      this.shippingLoading = true;
      Axios.get(this.baseUrl + "/onlineShop/installmentPayments/list", {
        headers: {
          Authorization: "Bearer: " + localStorage.getItem("shopToken"),
        },
      })
        .then((res) => {
          this.installmentItems = res.data;
          this.installmentItems.forEach((x) => {
            this.installmentItemsTitle.push(x.title);
          });
          this.select =
            this.installmentItems[this.installmentItems.length - 1].title;
        })
        .catch((err) => {
          console.error(err);
          this.toast(err.response.data, "error");
        })
        .finally(() => {
          this.shippingLoading = false;
        });
    },
    getguideList() {
      Axios.get(this.baseUrl + "/onlineShop/installmentPayments/guideList", {
        headers: {
          Authorization: "Bearer: " + localStorage.getItem("shopToken"),
        },
      })
        .then((res) => {
          if (res.status == 200) {
            this.guideList = res.data;
            const duration1Item = this.guideList.find(
              (item) => item.duration === 1
            );
            if (duration1Item) {
              this.minimumPrice = duration1Item.minimumPrice;
            }
          }
        })
        .catch((err) => {
          console.error(err);
          this.toast(err.response.data, "error");
        });
    },

    calculateInterest(isInstallment) {
      this.interestLoading = true;
      this.installmentPayment = this.installmentItems.filter(
        (x) => x.title == this.select
      )[0];
      Axios.post(
        this.baseUrl + "/onlineShop/cart/calculateInterest",
        {
          cartId: this.cartId,
          installmentPaymentId: this.installmentPayment.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("shopToken"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.installmentResponse = res.data;
            this.installmentResponseShow = true;
            this.installmentPaymentId = this.installmentPayment.id;
            this.interestLoading = false;
          } else {
            this.toast("خطایی رخ داده است. مجددا امتحان کنید.", "error");
            this.interestLoading = false;
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.interestLoading = false;
        });
    },
    editUseraddress() {
      const englishmobile = this.convertNumbers2English(
        this.editingAddress.mobile
      );
      const englishCode = this.convertNumbers2English(
        this.editingAddress.postalCode
      );
      Axios.patch(
        this.baseUrl + "/onlineShop/user/editAddress/" + this.editingAddress.id,
        {
          address: this.editingAddress.address,
          name: this.editingAddress.name,
          addressTitle: this.editingAddress.addressTitle,
          postalCode: englishCode,
          cityId: this.editingAddress.city
            ? this.editingAddress.city.id
            : undefined,
          stateId: this.editingAddress.stateId,
          district: this.editingAddress.district,
          mobile: englishmobile,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("shopToken"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.dialogEditAddress = false;
            this.toast(res.data.message, "success");
            this.getAll();
          } else {
            this.dialogEditAddress = false;
            this.toast("خطایی رخ داده است. مجددا امتحان کنید.", "error");
            this.getAll();
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.getAll();
          this.dialogEditAddress = false;
        });
    },
    selectAddress(item) {
      this.selectedAddress = item;
      // this.shippingAddress = this.selectedAddress;
      // this.emitter.emit("shippingAddress", this.selectedAddress);
      this.dialogAddres = false;
      this.isUserAddressCompleted = true;
    },
    shippingCostFunc() {
      Axios.post(
        this.baseUrl + "/onlineShop/item/shippingCost",
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("shopToken"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.shippingAddress = res.data.shippingAddress;
            // this.emitter.emit("shippingCost", res.data);
            this.shippingCost = res.data;
          } else {
            this.toast("خطایی رخ داده است. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    async validate() {
      const { valid } = await this.$refs.form.validate();

      if (valid) alert("Form is valid");
    },
    reset() {
      this.$refs.form.reset();
    },
    getAll() {
      Axios.get(this.baseUrl + "/onlineShop/user/address/list", {
        headers: {
          Authorization: "Bearer: " + localStorage.getItem("shopToken"),
        },
      })
        .then((res) => {
          if (res.status == 200) {
            this.addressesList = res.data;
            this.selectedAddress = this.addressesList
              ? this.addressesList[0]
              : {};
            if (this.addressesList.length && !this.selectedAddress.address)
              this.selectAddress(this.addressesList[0]);
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          console.error(err);
        });
    },
    handelOpenModal() {
      this.dialogAddres = !this.dialogAddres;
    },
    getStates() {
      Axios.get(this.baseUrl + "/onlineShop/states/list", {
        headers: {
          Authorization: "Bearer: " + localStorage.getItem("shopToken"),
        },
      })
        .then((res) => {
          this.states = res.data;
        })
        .catch((err) => {
          console.error(err);
          this.toast(err.response.data, "error");
        });
    },
    updateCity(type) {
      if (type == "editAddress") {
        this.editingAddress.cityId = "";
        this.getCities("editAddress");
      } else {
        this.newAddress.cityId = "";
        this.getCities("newAddress");
      }
    },

    updateEditingCity() {
      this.editingAddress.cityId = "";
      this.getEditedCities();
    },
    getCities(type) {
      let id =
        type === "newAddress"
          ? this.newAddress.stateId
          : this.editingAddress.stateId;
      this.gettingCitiesLoading = true;
      Axios.get(this.baseUrl + "/onlineShop/cities/listforstate/" + id, {
        headers: {
          Authorization: "Bearer: " + localStorage.getItem("shopToken"),
        },
      })
        .then((res) => {
          this.cities = res.data;
          this.gettingCitiesLoading = false;
        })
        .catch((err) => {
          console.error(err);
          this.toast(err.response.data, "error");
          this.gettingCitiesLoading = false;
        });
    },
    getEditedCities() {
      this.gettingCitiesLoading = true;
      Axios.get(
        this.baseUrl +
          "/onlineShop/cities/listforstate/" +
          this.editingAddress.stateId,
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("shopToken"),
          },
        }
      )
        .then((res) => {
          this.cities = res.data;
          this.gettingCitiesLoading = false;
        })
        .catch((err) => {
          console.error(err);
          this.toast(err.response.data, "error");
          this.gettingCitiesLoading = false;
        });
    },
    editAddress(item) {
      this.editingAddress = JSON.parse(JSON.stringify(item));
      this.getEditedCities();
      if (this.editingAddress && this.editingAddress.cityId) {
        this.editingAddress.city = {
          name: this.editingAddress.cityName,
          id: this.editingAddress.cityId,
        };
      }
      this.dialogEditAddress = true;
    },
    addAddress() {
      const englishmobile = this.convertNumbers2English(this.newAddress.mobile);
      const englishCode = this.convertNumbers2English(
        this.newAddress.postalCode
      );
      this.submitLoading = true;
      if (
        this.newAddress.address &&
        this.newAddress.mobile &&
        this.newAddress.postalCode &&
        this.newAddress.addressTitle &&
        this.newAddress.city.id &&
        this.newAddress.stateId
      ) {
        Axios.post(
          this.baseUrl + "/onlineShop/user/addAddress",
          {
            address: this.newAddress.address,
            name: this.newAddress.name,
            mobile: englishmobile,
            addressTitle: this.newAddress.addressTitle,
            postalCode: englishCode,
            cityId: this.newAddress.city ? this.newAddress.city.id : undefined,
            stateId: this.newAddress.stateId,
            district:
              this.newAddress.city && this.newAddress.city.name == "تهران"
                ? this.newAddress.district
                : undefined,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("shopToken"),
            },
          }
        )
          .then((res) => {
            this.submitLoading = false;
            this.toast("آدرس با موفقیت اضافه شد.", "success");
            this.dialogaddaddress = false;
            this.getAll();
            this.newAddress = {};
          })
          .catch((err) => {
            this.toast(err.response.data, "error");
            this.submitLoading = false;
          });
      } else {
        this.toast("لطفا همه ی فیلد ها را با دقت پر کنید", "error");
      }
    },
    changeRule(event) {
      this.rules = event;
    },
    checkout() {
      Axios.post(
        this.baseUrl + "/onlineShop/cart/checkout/" + this.cartId,
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("shopToken"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.shippingAddress = res.data.shippingAddress;
            this.isUserAddressCompleted = res.data.isUserAddressCompleted;
            this.checkoutAnswer = res.data;
            let finalCost = this.shippingCost + this.checkoutAnswer.totalCost;
            this.finalCost = finalCost;
            this.userHasName = res.data.userHasName ? true : false;
            // this.emitter.emit("finalCost", finalCost);
          } else {
            this.toast("خطایی رخ داده است. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          console.error(err);
          this.toast(err.response.data, "error");
        });
    },
    finalize() {
      this.loadingbtn = true;
      localStorage.removeItem("cart");

      if (!this.rules) {
        this.loadingbtn = false;
        this.toast("لطفا با قوانین خرید موافقت کنید.", "error");
      } else if (!this.selectedAddress.address) {
        this.loadingbtn = false;
        this.toast("لطفا یک آدرس برای ارسال انتخاب کنید.", "error");
      } else {
        const address = this.selectedAddress;
        Axios.post(
          this.baseUrl + "/onlineShop/cart/finalize/" + this.cartId,
          {
            name: localStorage.getItem("name"),
            ...address,
            installmentPaymentId:
              this.isInstallment && this.installmentPaymentId
                ? this.installmentPaymentId
                : null,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("shopToken"),
            },
          }
        )
          .then((res) => {
            if (res.status == 200) {
              this.loadingbtn = false;
              this.invoiceCode = res.data.invoiceCode;
              // this.emitter.emit("invoiceCode", res.data.invoiceCode);
              this.sendToPayProcess(res.data.id);
              // this.$router.push("/successfulPurchase");
            }
          })
          .catch((err) => {
            if (err.response.status == 409) {
              this.loadingbtn = false;
              this.toast(
                "برخی از اقلام سبد خرید شما نیازمند بازبینی است.",
                "error"
              );
              this.$router.push("/checkout/cart");
            } else {
              console.error(err.response);
              this.toast(err.response.data, "error");
            }
          });
      }
    },
    sendToPayProcess(id) {
      Axios.get(
        this.baseUrl + "/onlineShop/payment/createTransactionOld/" + id,
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("shopToken"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            let button = document.createElement("a");
            button.setAttribute("href", res.data);
            // button.setAttribute("target", "blank");
            button.click();
          } else if (res.status == 201) {
            this.submitLoading = false;
            this.$router.push("/successfulpurchase");
          }
        })
        .catch((err) => {
          console.error(err);
        });
      // },
    },
    editName() {
      Axios.patch(
        this.baseUrl + "/onlineShop/user/editName",
        { name: this.userName },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("shopToken"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data.message, "success");
            window.location.reload();
          } else {
            this.toast("خطایی رخ داده است. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          console.error(err);
          this.toast(err.response.data, "error");
        });
    },
  },
  mounted() {
    if (!localStorage.getItem("shopToken")) {
      this.$router.push("/");
      this.toast("ابتدا لاگین کنید", "error");
    } else {
      this.getInstallment();
      this.getguideList();
      this.installmentResponse = false;
      this.shippingCost = "shippingCost";
      this.cartId = localStorage.getItem("cartId");
      this.getStates();
      this.cartId = localStorage.getItem("cartId");
      this.cart = localStorage.getItem("cart")
        ? localStorage.getItem("cart")
        : [];

      this.checkout();
      for (let i = 1; i < 23; i++) {
        this.districts.push(i);
      }
      this.getAll();
      this.shippingCostFunc();
      // this.emitter.on("shippingCost", (shippingCost) => {
      //   this.shippingCost = shippingCost;
      // });
      this.cartId = localStorage.getItem("cartId");
      localStorage.removeItem("cart");
      // this.emitter.on("installmentResponse", (installmentResponse) => {
      //   this.installmentResponse = installmentResponse;
      // });
      this.installmentResponse = false;

      // this.emitter.on("shippingAddress", (shippingAddress) => {
      //   this.shippingAddress = shippingAddress;
      // });
      // this.emitter.on("installmentPaymentId", (installmentPaymentId) => {
      //   this.installmentPaymentId = installmentPaymentId;
      // });
    }
  },
  computed: {
    computedFinalCost() {
      let finalCost;
      finalCost = this.shippingCost + this.checkoutAnswer.totalCost;
      return finalCost;
    },
  },
  watch: {
    // select() {
    //   this.calculateInterest();
    // },
  },
};
</script>
<style lang="scss">
.fontSizemedium {
  font-size: 16px;
  @media only screen and (max-width: 1300px) {
    font-size: 15px;
  }
}
.fontSizesmall {
  font-size: 14px;
  @media only screen and (max-width: 1024px) {
    font-size: 13px;
  }
}
.items-rules,
.items-rule {
  display: flex;
  align-items: center;
  .icon_number_rule {
    h1 {
      color: #6200ea;
      font-size: 20px;
      font-weight: bolder;
      margin: 0 !important;
      margin-left: 10px !important;
    }
  }
  h5 {
    font-size: 15px;
    margin: 0 !important;
  }
}
.items-rule {
  .icon_number_rule {
    background: transparent;
  }
  h5 {
    color: #d62728;
  }
}
.root_Pages_user {
  display: flex;
  flex-direction: column;
}

.title_Product_Details {
  li {
    font-size: 17px;
    font-weight: 500;
    color: #6200ea;

    a {
      color: #73818f;
      font-size: 17px;
      font-weight: 500;
    }
  }

  .v-breadcrumbs-divider {
    color: #73818f;
    font-size: 17px;
    font-weight: 600;
  }
}

.card_modals {
  padding: 15px;
  .v-card__text {
    @media only screen and (max-width: 375px) {
      padding: 10px 5px !important;
    }
  }
}

.line-response_item {
  display: flex;
  flex-wrap: wrap;
  @media only screen and (max-width: 375px) {
    flex-direction: column;
  }
}

.title-PurchaseProcess {
  li {
    font-size: 18px;
    font-weight: 600;
    color: #3dd2b8;

    a {
      color: #9e9fb1;
      font-size: 18px;
      font-weight: 600;
    }
  }

  .v-breadcrumbs-divider {
    color: #9e9fb1;
    font-size: 18px;
    font-weight: 600;
  }
}

.no_space {
  padding: 0;
}

.root_purchase_process {
  display: flex;
  flex-wrap: wrap;
}

@media only screen and (max-width: 768px) {
  .root_purchase_process {
    flex-direction: column;
  }
}

.details_info_buy {
  padding: 0 !important;
  display: flex;
  justify-content: flex-start;
}

.details_info_buy_l {
  padding: 0 !important;
  display: flex;
  justify-content: flex-end;
}

.input_radio_select_items {
  cursor: pointer;

  .v-selection-control__wrapper {
    width: 20px !important;
    height: 20px !important;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .v-selection-control__input {
    opacity: 1 !important;
    width: 20px !important;
    height: 20px !important;

    input {
      opacity: 1 !important;
      background: var(--deep-purple-accent4) !important;
    }
  }
}

.items_type_payment {
  display: flex;
  flex-wrap: wrap;
}

.details_type_payment {
  display: flex;
  flex-direction: column;
}

.footer_modal_pay {
  display: flex;
  align-items: center;
  justify-content: space-between;

  span {
    font-size: 16px;
    font-weight: 500;
  }

  .footer_modal_pay-l {
    padding: 7px 15px;
  }

  .footer_modal_pay-r {
    padding: 7px 15px;
  }
}

.step_buy {
  display: flex;

  h3 {
    font-size: 14px;
    font-weight: 500;
    color: #666;
  }
}

.modal_Payment {
  width: 800px !important;

  h1 {
    color: #3dd2b8;
    font-size: 18px;
    font-weight: 500;
  }

  .v-overlay__content {
    border-radius: 12px;
  }

  .content_modal_pay {
    h6 {
      font-size: 14px;
      color: #23254e;
      font-weight: 500;
      line-height: 1.5rem;
      text-align: justify;
    }
  }
}
.img_modal_Payment {
  width: 100%;
  height: 190px;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
.img_check_Payment {
  width: 100%;
  height: 260px;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

.card_modal {
  padding: 20px 25px;
  display: flex;
  flex-direction: column;
}

.card_modal_Payment {
  padding-top: 5px;
  padding: 0 15px;
  display: flex;
  flex-direction: column;
}

.items_form_select_pay {
  display: flex;
  justify-content: space-between;
}

.btn_radio_Payment {
  display: flex;
  align-items: center !important;
}

.select_type_payment {
  .v-input__control {
    padding: 0 !important;
    margin: 0 !important;
    border-radius: 8px;
    height: 55px;
    color: #000;
    border: 2px solid var(--teal-accent-3) !important;
    box-shadow: none !important;
    padding: 5px 15px;
    transition: 0.4s;

    .v-overlay__content {
      right: 0 !important;
      top: 0;
    }
  }

  .v-field--variant-solo {
    box-shadow: none !important;
    padding: 0 !important;
    margin: 0 !important;

    .v-field__append-inner {
      height: 55px;

      i {
        color: var(--teal-accent-3) !important;
        font-size: 25px;
      }
    }
  }
}

.primary-btn {
  background-color: #001ebd;
  color: white;
}

.image-box {
  height: 260px !important;
  width: 500px !important;
  position: center !important;
  background-size: cover !important;
}

.table_modal_payment {
  thead {
    tr {
      th {
        font-size: 14px;
      }
    }
  }

  tbody {
    tr {
      td {
        font-size: 14px;
      }
    }
  }
}

@media only screen and (max-width: 1024px) {
  .modal_Payment {
    .v-overlay__content {
      top: 20px;
      width: auto;
    }
  }
}

@media only screen and (max-width: 768px) {
  .modal_Payment {
    .v-overlay__content {
      top: 20px;
      width: 80%;
    }

    h1 {
      font-size: 16px;
    }

    .content_modal_pay {
      h6 {
        font-size: 13px;
      }
    }
  }

  .img_modal_Payment {
    height: 200px;
  }
}
.discount-text {
  h5 {
    color: #3dd2b8;
  }
}
.text_content_Process {
  display: flex;
  flex-wrap: wrap;
}
@media only screen and (max-width: 600px) {
  .modal_Payment {
    width: 300px;
    height: 400px;

    .v-overlay__content {
      width: 300px;
      height: 400px;
      top: 20px;
      left: 0;
      right: 0;
    }

    h1 {
      font-size: 14px;
    }
  }

  .card_modal {
    padding: 10px 15px;
  }

  .card_modal_Payment {
    padding: 0 !important;
  }

  .table_modal_payment {
    thead {
      tr {
        th {
          font-size: 12px;
        }
      }
    }

    tbody {
      tr {
        td {
          font-size: 12px;
        }
      }
    }
  }
}

.details_addres_box {
  display: flex;
  align-items: center;

  h5,
  h6 {
    font-size: 18px;
    font-weight: 600;
    color: var(--mainFont);
    margin-left: 5px;
  }

  h5 {
    color: var(--mainFont);
    font-weight: 500;
    font-size: 18px;
  }

  svg {
    width: 22px;
    height: 22px;
    color: var(--deep-purple-accent4);
    margin-left: 5px;
  }
}

.line_form_address {
  border: 1px solid var(--mainFont);
}

.select_address {
  border: 3px solid #a076f9 !important;
  box-shadow: rgba(215, 187, 245, 1) 0px 7px 29px 0px !important;
  border-radius: 8px !important;
  overflow: hidden !important;
  height: auto;
  padding: 16px 10px;
  width: 100%;
  margin-bottom: 10px;
  background-color: white;
}

.items_select_address {
  font-size: 18px;
  color: var(--lightText);
  font-weight: 600;
  margin-right: 20px;
}

.items_addres_box {
  display: flex;
  align-items: center;

  svg {
    width: 25px;
    height: 25px;
    color: var(--deep-purple-accent4);
    margin-left: 5px;
  }
}

.details_addres_box {
  display: flex;
  align-items: center;

  h5,
  h6 {
    font-size: 18px;
    font-weight: 600;
    color: var(--mainFont);
    margin-left: 5px;
  }

  h5 {
    color: var(--mainFont);
    font-weight: 500;
    font-size: 18px;
  }

  svg {
    width: 22px;
    height: 22px;
    color: var(--deep-purple-accent4);
    margin-left: 5px;
  }
}

.space_top {
  padding-top: 10px;
}

.modal_select_address,
.add-address_modal {
  .v-overlay__content {
    width: 800px !important;
    border-radius: 8px;
    overflow-y: auto;
    white-space: nowrap;
  }
}

.add-address_modal {
  padding: 10px 15px;

  .v-overlay__content {
    padding: 10px 15px;
  }
}

.form_add_address_modal {
  display: flex;
  flex-wrap: wrap;
}

.box_modal_address {
  padding: 15px;
}

.btn_edit_address {
  color: var(--deep-purple-accent4);

  svg {
    width: 25px;
    height: 25px;
    color: var(--deep-purple-accent4);
  }
}

.title_select_address {
  font-size: 16px;
  font-weight: 600;
  color: var(--lightText);
}

.linemodal {
  border-bottom: 2px dashed var(--deep-purple-accent4);
}

.add_new_address {
  color: #23254e;

  svg {
    width: 22px;
    height: 22px;
  }
}

.radio_address {
  input[type="radio"] + label:before {
    content: "";
    top: -10px !important;
  }
}

@media only screen and (max-width: 1024px) {
  .modal_select_address,
  .add-address_modal {
    height: 450px;

    .v-overlay__content {
      bottom: 13rem;
      width: auto;
      height: 450px;
    }
  }
}

@media only screen and (max-width: 767px) {
  .form_add_address_modal {
    display: flex;
    flex-direction: column;
  }
}

@media only screen and (max-width: 768px) {
  .form_add_address_modal {
    display: flex;
  }

  .select_address {
    padding: 10px;
  }

  .details_addres_box {
    h5,
    h6 {
      font-weight: 600;
      font-size: 16px;
    }
  }

  .space_top {
    padding-top: 20px;
  }

  .items_select_address {
    color: var(--lightText);
    font-weight: 600;
  }

  .modal_select_address,
  .add-address_modal {
    width: auto;
    height: 450px;
  }

  .add-address_modal {
    padding: 5px;
  }
}
.rules-card {
  border-radius: 15px !important;
  padding: 15px;
  max-height: 680px;
  overflow-y: auto;
  .custom-input {
    .v-textarea {
      .v-input__slot {
        height: 246px !important;
      }
    }
    .v-input__slot {
      width: 100% !important;
    }
    .v-input__icon--append {
      padding-top: 3px !important;
      i {
        color: #7c4dff !important;
        cursor: pointer;
      }
    }
  }
}
.line-modal-rules {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.info-card {
  @media only screen and (min-width: 960px) {
    width: 50%;
  }
}
</style>
